import { render, staticRenderFns } from "./Reseller.vue?vue&type=template&id=72b54d32&scoped=true&"
import script from "./Reseller.vue?vue&type=script&lang=js&"
export * from "./Reseller.vue?vue&type=script&lang=js&"
import style0 from "./Reseller.vue?vue&type=style&index=0&id=72b54d32&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b54d32",
  null
  
)

export default component.exports